// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Tooltip_overlay___MOzE","animation-tooltip-content":"Tooltip_animation-tooltip-content__0SimF","overlayArrow":"Tooltip_overlayArrow__Md3xJ"};